import { FetchUserCompetenciesSortTypes } from './userCompetenciesTypes';

export const INITIAL_USER_COMPETENCIES_FILTERS = {};
export const INITIAL_USER_COMPETENCIES_PAGE = 1;
export const INITIAL_USER_COMPETENCIES_SORT = [
  FetchUserCompetenciesSortTypes.CREATED_AT_DESC
];
export const INITIAL_USER_COMPETENCIES_LIMIT = 100;
